/*eslint-disable*/ export const messages = JSON.parse("{\"toast.aria.error\":[\"Feil\"],\"toast.aria.successful\":[\"Vellykket\"],\"toast.aria.warning\":[\"Advarsel\"]}");
//# sourceMappingURL=messages.mjs.map